import React, { Component } from 'react';
import { 
  Row, 
  Col, 
  Form, 
} from 'react-bootstrap';

class MyRole extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      displayRole: '',
      error: ''
    };
  };

  componentDidMount = async () => {
    const currRole = this.props.profile.getDefaultProfile().myRole;
    this.setState({
      displayRole: currRole || ''
    })
  }

  onBlur = event => {
    event.preventDefault();
    const { displayRole } = this.state;
    this.props.profile.getDefaultProfile().myRole = displayRole;
    this.props.profile.save();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    return (
      <Form.Group>
        <Row className='text-left'>
          <Col>
            <Form.Label>My Role</Form.Label> 
            <Form.Control
              name='displayRole'
              value={this.state.displayRole}
              onBlur={this.onBlur}
              onChange={this.onChange}
              type='text'
              maxLength= {20}
              placeholder="max 20 characters"
            />
        
     
          </Col>
        </Row>
      </Form.Group>
     )
  }
};

export default MyRole;